import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardHint], [campus-card-hint], campus-card-hint',
})
export class CardHintDirective {
  @HostBinding('class')
  defaultClasses = ['absolute', 'top-none', 'left-none', 'right-none', 'index-content-on-surface'];
}
